import { NavLink, Navigate, Outlet, Link, useNavigate } from "react-router-dom";
import { Boxes, ShoppingBag, Users, Mail, LayoutDashboard, LogOut, ExternalLink } from "lucide-react";
import { useAdminAuth } from "../../lib/auth";

const AdminLayout = () => {
  const { isAuthed, email, logout } = useAdminAuth();
  const navigate = useNavigate();

  if (!isAuthed) return <Navigate to="/admin/login" replace />;

  const items = [
    { to: "/admin", label: "Overview", icon: LayoutDashboard, end: true, testId: "admin-nav-overview" },
    { to: "/admin/products", label: "Products", icon: Boxes, testId: "admin-nav-products" },
    { to: "/admin/orders", label: "Orders", icon: ShoppingBag, testId: "admin-nav-orders" },
    { to: "/admin/customers", label: "Customers", icon: Users, testId: "admin-nav-customers" },
    { to: "/admin/subscribers", label: "Subscribers", icon: Mail, testId: "admin-nav-subscribers" },
  ];

  const handleLogout = () => {
    logout();
    navigate("/admin/login");
  };

  return (
    <div className="admin-shell grid grid-cols-12 min-h-screen" data-testid="admin-shell">
      <aside className="admin-side col-span-12 md:col-span-3 lg:col-span-2 md:min-h-screen flex md:flex-col">
        <Link to="/" className="px-6 py-6 md:py-8 flex md:block items-center justify-between border-b md:border-b-0 border-white/10 w-full hover:opacity-80 transition-opacity" data-testid="admin-view-store-logo">
          <div>
            <div className="overline" style={{ color: "rgba(255,255,255,0.7)" }}>Swenkville</div>
            <div className="font-display text-2xl mt-1" style={{ letterSpacing: "0.05em" }}>ADMIN</div>
          </div>
        </Link>
        <nav className="flex md:flex-col flex-1 overflow-x-auto md:overflow-y-auto" data-testid="admin-sidenav">
          {items.map(({ to, label, icon: Icon, end, testId }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={testId}
              className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
            >
              <Icon size={14} strokeWidth={1.5} />
              <span>{label}</span>
            </NavLink>
          ))}
          <Link
            to="/"
            className="nav-item"
            data-testid="admin-view-store-link"
          >
            <ExternalLink size={14} strokeWidth={1.5} />
            <span>View Store</span>
          </Link>
        </nav>
        <div className="hidden md:block p-6 border-t border-white/10 text-xs" style={{ color: "rgba(255,255,255,0.5)" }}>
          <div className="overline mb-1" style={{ color: "rgba(255,255,255,0.7)" }}>Signed in</div>
          <div className="truncate">{email}</div>
          <button onClick={handleLogout} className="mt-3 inline-flex items-center gap-2 text-white/70 hover:text-white" data-testid="admin-logout-btn">
            <LogOut size={12} /> Logout
          </button>
        </div>
      </aside>
      <main className="col-span-12 md:col-span-9 lg:col-span-10 p-6 md:p-10" data-testid="admin-main">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
